<template>
  <div>
    <div v-if="showDetails" class="tw-mt-1 tw-mb-6">
      <div class="tw-inline-grid tw-grid-flow-col tw-items-center tw-gap-3">
        <div class="tw-w-13 tw-h-13">
          <BaseArtwork class="tw-rounded tw-overflow-hidden"
                       :src="soundkit.image(300)"
                       :image-size="300" />
        </div>
        <div>
          <div class="tw-font-bold tw-text-2xl tw-text-infinity-highlight">Buy this pack</div>
          <router-link
              class="tw-inline-block tw-text-md hover:tw-underline tw-text-infinity-tertiary-text"
              @click.native="$modal.hide('soundkit-pricing')"
              :to="{name: 'soundkit', params: {soundkit: soundkit.id}}">{{ soundkit.name }}
          </router-link>
        </div>
      </div>
    </div>
    <div v-else class="tw-font-bold tw-text-2xl tw-mb-5 tw-text-infinity-highlight">Buy this pack</div>
    <div class="tw-grid tw-gap-4 soundkit-pricing-cols">
      <SoundkitPricingOption v-for="(pricingOption) in soundkit.productPricing"
                             @click="soundkit.addToCart(pricingOption)"
                             :active="inCart(pricingOption)"
                             :pricing-option="pricingOption"
                             :key="pricingOption.id" />
    </div>
  </div>
</template>
<script>
import SoundkitPricingOption from "./soundkit-pricing-option";
import SoundKit from "../../../models/soundkit";
import BaseArtwork from "../../base/base-artwork";

export default {
  components: { BaseArtwork, SoundkitPricingOption },
  props: {
    soundkit: {
      type: SoundKit,
      required: true
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    inCart(pricingOption) {
      return this.soundkit.inCart(pricingOption);
    }
  }
};
</script>
<style lang="scss" scoped>
.soundkit-pricing-cols {
  grid-template-columns: repeat(auto-fill, minmax(307px, 1fr));
}
</style>
